import { orderBy } from 'lodash'

const events = [
  { value: 'create', text: 'Inserir' },
  { value: 'destroy', text: 'Remover' },
  { value: 'update', text: 'Atualizar' },
]

const models = [
  { value: "MedicalReportSetting", text: "Configurações de filas de trabalho" },
  { value: "MedicalReportTemplate::DoctorSignature", text: "Assinaturas" },
  { value: "MedicalReportTemplate::HeaderFooter", text: "Cabeçalhos e rodapés" },
  { value: "Outbox", text: "Caixa de saída" },
  { value: "DefaultTemplateConfig", text: "Configurações de template padrão" },
  { value: "OrganizationBranch", text: "Empresa" },
  { value: "Exam", text: "Exame" },
  { value: "MedicalReport", text: "Laudo" },
  { value: "Notification", text: "Notificação" },
  { value: "Organization", text: "Parâmetros do Sistema" },
  { value: "Role", text: "Perfil" },
  { value: "EmailTemplate", text: "Template de email" },
  { value: "MedicalReportTemplate", text: "Template de laudo" },
  { value: "User", text: "Usuário" },
]

export default {
  events: orderBy(events, [item => item.text]),
  models: orderBy(models, [item => item.text])
}
